import { Injectable } from '@angular/core';
import { InAppBrowser, InAppBrowserOptions} from '@ionic-native/in-app-browser/ngx';
import { TranslateService } from '@ngx-translate/core';
import { PlatformService } from './device/platform.service';

@Injectable({
    providedIn: 'root'
})
export class BrowserPopupService {

    public isOpen = false;

    constructor(
        private inAppBrowser: InAppBrowser,
        private platformService: PlatformService,
        private translate: TranslateService
    ) { }

    public async open(link: string) {
        const options: InAppBrowserOptions = { location: 'yes' };

        if (this.platformService.isNative()) {
            options.closebuttoncolor = '#FFFFFF';
            options.closebuttoncaption = await this.translate.get('BACK').toPromise();
            options.toolbarcolor = '#000000';

            if (this.platformService.isIos()) {
                options.location = 'no';
                options.toolbar = 'yes';
                options.toolbarposition = 'top';
                options.toolbartranslucent = 'no';
            } else {
                options.hideurlbar = 'yes';
                options.hidenavigationbuttons = 'yes';
            }
        }

        const browser = this.inAppBrowser.create(link, '_blank', options);
        browser.on('loadstop').subscribe(_ => {
            if (this.platformService.isIos()) {
                this.fixPopups(browser);
            }
         });
        browser.on('exit').subscribe(_ => {
            this.isOpen = false;
        });
        browser.show();
        this.isOpen = true;
    }

    private fixPopups(browser) {
        browser.executeScript({code: 'window.open = (url) => document.location.href = url;'});
    }
}
